/**
 * Platform-owned contact details that the dashboard SHOWS to staff and vendors.
 *
 * The WhatsApp sender is the number every vendor alert arrives from, so it is
 * quoted on the vendor's own Alert settings panel and twice in the platform
 * wiki. It was hardcoded in all three, which meant a change of number was three
 * edits and any one of them could be missed. Change it HERE ONLY.
 *
 * Display strings, not configuration: nothing here is a credential, and nothing
 * here decides where a message is actually sent from. The sending identity
 * lives in the server's WhatsApp provider settings.
 */
export const WHATSAPP_SENDER_NUMBER = "+256 785 010102";

/** The name that shows on a handset next to that number. */
export const WHATSAPP_SENDER_NAME = "Suku CS";

/** How the sender is written in copy: the number, then the name in brackets. */
export const WHATSAPP_SENDER = `${WHATSAPP_SENDER_NUMBER} (${WHATSAPP_SENDER_NAME})`;
